export function writeGaEvent() {
  console.info('GA Event disabled.')
}
